import { groupBy } from "lodash";
import moment from "moment";
import React from "react";
import { Col, Row } from "react-bootstrap";
import SimpleCard from "../../SimpleCard/SimpleCard";
import { useIntl } from "react-intl";
import { KeywordsByDay } from "src/app/types/planning";
import { Site } from "src/app/types/Site";

export interface IResumeBoost {
    months: number;
    moneySite: Site;
    kwBoost: Array<KeywordsByDay>;
}
const ResumeBoost: React.FC<IResumeBoost> = ({ kwBoost, moneySite, months }: IResumeBoost) => {
    const { formatMessage } = useIntl();
    const keywordsByMonth = groupBy(kwBoost, ({ date }) => {
        if (date?.includes("-")) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("MM/YYYY");
        } else {
            return moment(date, "DD/MM/YYYY").format("MM/YYYY");
        }
    });

    return (
        <Row>
            <Row>
                <Col>
                    <p>
                        {formatMessage(
                            { id: "planning.boostResume" },
                            {
                                domain: moneySite.domain,
                                boost: moneySite?.content?.boost || 0,
                                months,
                                boostOrder: months * (moneySite?.content?.boost || 0),
                            }
                        )}
                    </p>
                </Col>
            </Row>

            <Row>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: "16px",
                    }}
                >
                    {Object.keys(keywordsByMonth)
                        .filter((el) => el !== "Invalid date")
                        ?.map((value: string, indexMonth: number) => (
                            <SimpleCard
                                header={value}
                                cardProps={{
                                    style: {
                                        background: "var(--kt-primary)",
                                        color: "white",
                                        fontWeight: "600",
                                        lineHeight: "1.5rem",
                                    },
                                }}
                                headerProps={{
                                    style: {
                                        fontSize: "18px",
                                        minHeight: "32px",
                                        display: "flex",
                                        alignContent: "center",
                                    },
                                }}
                                key={indexMonth}
                            >
                                <>
                                    {keywordsByMonth[value].map((el, index) => (
                                        <span key={index}>
                                            <i style={{ color: "white" }}>{el.date} </i> :{" "}
                                            {el.keyword}
                                            <br />
                                        </span>
                                    ))}
                                </>
                            </SimpleCard>
                        ))}
                </div>
            </Row>
        </Row>
    );
};
export default ResumeBoost;
